// extracted by mini-css-extract-plugin
export default {"tag":"tags_tag__pY9Rw"};